import axios from 'axios';
import url from '../constants/url';
import {getLocale} from '@epic-core/common';

export const getPageData = async cmsUrlPattern => {
    const locale = getLocale();
    if (!locale || !cmsUrlPattern) {
        throw new Error('getPageData() requires a locale and a cmsUrlPattern');
    }
    const api = url().CMS_PAGE_DATA(locale, cmsUrlPattern);
    if (!api) {
        throw new Error('getPageData() requires a valid locale and a cmsUrlPattern');
    }
    console.log(`CmsSource.getPageData() trying ${api}`);
    let response = {};
    try {
        response = await axios(api, {
            timeout: 5000
        });
    } catch (e) {
        console.log(`CmsSource.getPageData() failed to load cms page ${cmsUrlPattern}`);
        console.error(e.message);
        throw e;
    }
    const data = response.data || {};
    if (response.status === 200 && typeof data === 'object' && data._urlPattern) {
        return data;
    }
    console.log('CmsSource.getPageData() response was not an object or did not contain the _urlPattern field', response.status);
    return null;
};

export const getRootPageData = (locale, cmsUrlPattern) => {
    const api = url().CMS_ROOTPAGE_DATA(locale, cmsUrlPattern);
    return axios(api).catch(e => {
        console.log('CmsSource.getRootPageData() failed to load cms page', cmsUrlPattern);
        console.error(e.message);
    });
};
